/**
 * CILSON 3D Kanalplaner PRO - UI Layer
 * Basis-Wandansicht (2D-Canvas) + Produkt-/Farbauswahl + Segment-Editor +
 * Zuschnitt-Zusammenfassung + Shopify Ajax-Cart-Integration.
 *
 * Hinweis zum Umfang: Aus den technischen Rahmenbedingungen dieser Arbeitsumgebung
 * (kein Build-System, kein Bundler) wird hier zunaechst die 2D-Basisansicht umgesetzt,
 * die auf allen Geraeten (Desktop/Tablet/Mobile) voll funktionsfaehig ist (Sec. 16 der
 * Spezifikation erlaubt eine vereinfachte 2D-Ansicht als Basis, sofern Daten/Funktionen
 * identisch bleiben). Eine zusaetzliche 3D-Visualisierung (Three.js) ist als naechster
 * Ausbauschritt vorgesehen und wird in cilson-progress.md als offener Punkt gefuehrt.
 *
 * Alle Fertigungsmasse werden als ganze Millimeter behandelt.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function parsePackagingMultiplier(text) {
    if (!text) return 1;
    var match = String(text).match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }

  function formatMoney(amountCents) {
    var value = (Number(amountCents) || 0) / 100;
    return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function uuid() {
    return 'seg-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function init() {
    var root = document.getElementById('cilson-kp-root');
    if (!root) return;

    var dataScript = document.getElementById('cilson-kanalplaner-data');
    var data = { products: [] };
    try {
      data = JSON.parse(dataScript ? dataScript.textContent : '{}');
    } catch (e) {
      console.error('CilsonKanalplaner: Produktdaten konnten nicht gelesen werden.', e);
    }

    var engine = window.CilsonCuttingEngine;
    if (!engine) {
      console.error('CilsonKanalplaner: cilson-cutting-engine.js wurde nicht geladen.');
      return;
    }

    var stockLengthMm = parseInt(root.getAttribute('data-stock-length-mm'), 10) || engine.DEFAULT_STOCK_LENGTH_MM;
    var defaultSawKerfMm = parseInt(root.getAttribute('data-saw-kerf-mm'), 10);
    if (isNaN(defaultSawKerfMm)) defaultSawKerfMm = engine.DEFAULT_SAW_KERF_MM;
    var defaultMinLeftoverMm = parseInt(root.getAttribute('data-min-leftover-mm'), 10);
    if (isNaN(defaultMinLeftoverMm)) defaultMinLeftoverMm = engine.DEFAULT_MIN_LEFTOVER_MM;

    var els = {
      statusBadge: document.getElementById('cilson-kp-status-badge'),
      emptyState: document.getElementById('cilson-kp-empty-state'),
      layout: document.getElementById('cilson-kp-layout'),
      loading: document.getElementById('cilson-kp-loading'),
      productSelect: document.getElementById('cilson-kp-product-select'),
      colorRow: document.getElementById('cilson-kp-color-row'),
      priceValue: document.getElementById('cilson-kp-price-value'),
      segmentLength: document.getElementById('cilson-kp-segment-length'),

      addSegmentBtn: document.getElementById('cilson-kp-add-segment-btn'),
      summaryBody: document.getElementById('cilson-kp-summary-body'),
      rodSummary: document.getElementById('cilson-kp-rod-summary'),
      resetBtn: document.getElementById('cilson-kp-reset-btn'),
      addToCartBtn: document.getElementById('cilson-kp-add-to-cart-btn'),
      canvas: document.getElementById('cilson-kp-canvas')
    };

    var state = {
      products: data.products || [],
      selectedProduct: null,
      selectedColorCode: null,
      segments: [],
      cuttingResult: null
    };

    if (!state.products.length) {
      els.loading.style.display = 'none';
      els.emptyState.style.display = 'block';
      els.statusBadge.textContent = 'Keine Produkte verfuegbar';
      return;
    }

    els.loading.style.display = 'none';
    els.layout.style.display = 'grid';
    els.statusBadge.textContent = state.products.length + ' Profile geladen';

    function productsByHandle() {
      var map = {};
      state.products.forEach(function (p) { map[p.handle] = p; });
      return map;
    }

    function uniqueBy(list, keyFn) {
      var seen = {};
      var out = [];
      list.forEach(function (item) {
        var k = keyFn(item);
        if (!seen[k]) { seen[k] = true; out.push(item); }
      });
      return out;
    }

    function populateProductSelect() {
      var families = uniqueBy(state.products, function (p) {
        return p.profileWidthMm + 'x' + p.profileHeightMm;
      });
      els.productSelect.innerHTML = '';
      families.forEach(function (p) {
        var opt = document.createElement('option');
        opt.value = p.profileWidthMm + 'x' + p.profileHeightMm;
        opt.textContent = p.profileWidthMm + ' x ' + p.profileHeightMm + ' mm';
        els.productSelect.appendChild(opt);
      });
    }

    function currentDimensionKey() {
      return els.productSelect.value;
    }

    function productsForDimension(dimKey) {
      return state.products.filter(function (p) {
        return (p.profileWidthMm + 'x' + p.profileHeightMm) === dimKey;
      });
    }

    function populateColorRow() {
      var dimKey = currentDimensionKey();
      var variantsForDim = productsForDimension(dimKey);
      els.colorRow.innerHTML = '';
      variantsForDim.forEach(function (p, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cilson-kp__color-swatch';
        btn.title = p.profileColor;
        btn.style.background = p.profileColorCode || '#ccc';
        btn.setAttribute('aria-pressed', idx === 0 ? 'true' : 'false');
        btn.setAttribute('data-handle', p.handle);
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(els.colorRow.children, function (c) {
            c.setAttribute('aria-pressed', 'false');
          });
          btn.setAttribute('aria-pressed', 'true');
          selectProduct(p.handle);
        });
        els.colorRow.appendChild(btn);
      });
      if (variantsForDim.length) selectProduct(variantsForDim[0].handle);
    }

    function selectProduct(handle) {
      var map = productsByHandle();
      state.selectedProduct = map[handle];
      updatePriceLabel();
      recalculate();
    }

    function baseRodVariant(product) {
      if (!product || !product.variants || !product.variants.length) return null;
      var withMultiplier = product.variants.map(function (v) {
        return { variant: v, multiplier: parsePackagingMultiplier(v.packagingOption || v.title) };
      });
      withMultiplier.sort(function (a, b) { return a.multiplier - b.multiplier; });
      return withMultiplier[0].variant;
    }

    function updatePriceLabel() {
      var variant = baseRodVariant(state.selectedProduct);
      if (variant) {
        els.priceValue.textContent = formatMoney(variant.price) + ' / Stab (' + stockLengthMm + 'mm)';
      } else {
        els.priceValue.textContent = '-';
      }
    }

    function addSegment() {
      var lenValue = parseInt(els.segmentLength.value, 10);
      if (!lenValue || lenValue <= 0) {
        window.alert('Bitte eine gueltige Laenge in mm eingeben (groesser als 0).');
        return;
      }
      if (!state.selectedProduct) {
        window.alert('Bitte zuerst ein Profil und eine Farbe auswaehlen.');
        return;
      }
      state.segments.push({
        uuid: uuid(),
        productHandle: state.selectedProduct.handle,
        colorCode: state.selectedProduct.profileColorCode || state.selectedProduct.profileColor,
        finishedLengthMm: lenValue
      });
      els.segmentLength.value = '';
      recalculate();
    }

    function removeSegment(segUuid) {
      state.segments = state.segments.filter(function (s) { return s.uuid !== segUuid; });
      recalculate();
    }

    function recalculate() {
      if (!state.segments.length) {
        state.cuttingResult = null;
        renderSummary();
        renderCanvas();
        updateAddToCartState();
        return;
      }
      try {
        var numbered = engine.assignPositionNumbers(state.segments);
        var split = engine.splitOversizedSegments(numbered, stockLengthMm);
        var sawKerfMm = state.selectedProduct && state.selectedProduct.sawKerfMm != null
          ? state.selectedProduct.sawKerfMm : defaultSawKerfMm;
        var result = engine.optimizeCutting(split, {
          stockLengthMm: stockLengthMm,
          sawKerfMm: sawKerfMm,
          minLeftoverMm: defaultMinLeftoverMm
        });
        state.cuttingResult = result;
      } catch (e) {
        console.error('CilsonKanalplaner: Fehler bei der Zuschnittberechnung.', e);
        state.cuttingResult = null;
      }
      renderSummary();
      renderCanvas();
      updateAddToCartState();
    }

    function renderSummary() {
      els.summaryBody.innerHTML = '';
      state.segments.forEach(function (seg, idx) {
        var tr = document.createElement('tr');
        var tdPos = document.createElement('td');
        tdPos.textContent = String(idx + 1);
        var tdLen = document.createElement('td');
        tdLen.textContent = seg.finishedLengthMm + ' mm' + (seg.finishedLengthMm > stockLengthMm ? ' (wird gesplittet)' : '');
        var tdAction = document.createElement('td');
        var removeBtn = document.createElement('button');
        removeBtn.className = 'cilson-kp__btn';
        removeBtn.textContent = 'Entfernen';
        removeBtn.type = 'button';
        removeBtn.addEventListener('click', function () { removeSegment(seg.uuid); });
        tdAction.appendChild(removeBtn);
        tr.appendChild(tdPos); tr.appendChild(tdLen); tr.appendChild(tdAction);
        els.summaryBody.appendChild(tr);
      });

      if (!state.cuttingResult) {
        els.rodSummary.innerHTML = '';
        return;
      }
      var r = state.cuttingResult;
      var html = '<strong>' + r.totalRods + '</strong> Rohstab(e) a ' + stockLengthMm + 'mm noetig.';
      if (r.leftovers.length) {
        html += '<br>Reststuecke: ';
        html += r.leftovers.map(function (l) {
          var cls = l.decision === 'deliver' ? 'cilson-kp__badge--deliver' : 'cilson-kp__badge--recycle';
          return '<span class="cilson-kp__badge ' + cls + '">' + l.id + ': ' + l.lengthMm + 'mm (' + l.decision + ')</span>';
        }).join(' ');
      }
      els.rodSummary.innerHTML = html;
    }

    function renderCanvas() {
      var canvas = els.canvas;
      if (!canvas) return;
      var parent = canvas.parentElement;
      canvas.width = parent.clientWidth || 800;
      canvas.height = parent.clientHeight || 480;
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#f5f5f5';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      if (!state.segments.length) {
        ctx.fillStyle = '#6b6b6b';
        ctx.font = '14px sans-serif';
        ctx.fillText('Noch keine Segmente platziert. Links Laenge eingeben und hinzufuegen.', 20, 30);
        return;
      }

      var totalLen = state.segments.reduce(function (sum, s) { return sum + s.finishedLengthMm; }, 0);
      var marginX = 40;
      var usableWidth = canvas.width - marginX * 2;
      var scale = totalLen > 0 ? Math.min(usableWidth / totalLen, 0.6) : 0.2;
      var y = canvas.height / 2;
      var x = marginX;

      ctx.strokeStyle = '#d9d9d9';
      ctx.beginPath();
      ctx.moveTo(marginX, y + 40);
      ctx.lineTo(canvas.width - marginX, y + 40);
      ctx.stroke();

      state.segments.forEach(function (seg, idx) {
        var w = Math.max(seg.finishedLengthMm * scale, 4);
        ctx.fillStyle = seg.colorCode && /^#/.test(seg.colorCode) ? seg.colorCode : '#ff5a00';
        ctx.strokeStyle = '#1a1a1a';
        ctx.fillRect(x, y - 20, w, 40);
        ctx.strokeRect(x, y - 20, w, 40);
        ctx.fillStyle = '#1a1a1a';
        ctx.font = 'bold 12px sans-serif';
        ctx.fillText(String(idx + 1), x + 4, y + 4);
        ctx.font = '11px sans-serif';
        ctx.fillText(seg.finishedLengthMm + 'mm', x + 4, y + 34);
        x += w;
      });
    }

    function updateAddToCartState() {
      var canAdd = !!(state.cuttingResult && state.cuttingResult.totalRods > 0 && state.selectedProduct);
      els.addToCartBtn.disabled = !canAdd;
    }

    function buildProjectToken() {
      var payload = {
        v: 1,
        createdAt: new Date().toISOString(),
        productHandle: state.selectedProduct.handle,
        colorCode: state.selectedProduct.profileColorCode,
        segments: state.segments,
        cuttingResult: state.cuttingResult
      };
      try {
        return btoa(unescape(encodeURIComponent(JSON.stringify(payload)))).slice(0, 4000);
      } catch (e) {
        return '';
      }
    }

    function addToCart() {
      if (!state.cuttingResult || !state.selectedProduct) return;
      var variant = baseRodVariant(state.selectedProduct);
      if (!variant) {
        window.alert('Fuer dieses Profil wurde keine passende Rohstab-Variante gefunden.');
        return;
      }
      if (!variant.available) {
        window.alert('Die ausgewaehlte Variante ist aktuell nicht verfuegbar. Bitte Farbe/Profil pruefen.');
        return;
      }

      var cutSummary = state.cuttingResult.rods.map(function (rod) {
        return 'Stab ' + rod.rodNumber + ': ' + rod.pieces.map(function (p) {
          return 'Pos ' + p.positionNumber + ' (' + (p.endMm - p.startMm) + 'mm)';
        }).join(', ');
      }).join(' | ');

      var positions = state.segments.map(function (s, i) { return (i + 1) + ':' + s.finishedLengthMm + 'mm'; }).join(', ');
      var leftoverChoice = state.cuttingResult.leftovers.map(function (l) { return l.id + '=' + l.decision; }).join(', ');

      var payload = {
        items: [{
          id: variant.variantId,
          quantity: state.cuttingResult.totalRods,
          properties: {
            'Kanalprofil': state.selectedProduct.profileWidthMm + 'x' + state.selectedProduct.profileHeightMm + 'mm, ' + state.selectedProduct.profileColor,
            'Bestellung': state.segments.map(function (s) { return s.finishedLengthMm + 'mm'; }).join(' + ') + ' (' + state.cuttingResult.totalRods + ' Stab/Staeben a ' + stockLengthMm + 'mm)',
            '_cilson_project_name': 'Kanalplaner-Projekt ' + new Date().toLocaleDateString('de-DE'),
            '_cilson_configuration_version': '1',
            '_cilson_profile': state.selectedProduct.profileWidthMm + 'x' + state.selectedProduct.profileHeightMm + 'mm',
            '_cilson_color': state.selectedProduct.profileColor,
            '_cilson_stock_length': stockLengthMm + 'mm',
            '_cilson_stock_count': String(state.cuttingResult.totalRods),
            '_cilson_cut_summary': cutSummary,
            '_cilson_positions': positions,
            '_cilson_leftover_choice': leftoverChoice || 'keine',
            '_cilson_project_token': buildProjectToken()
          }
        }]
      };

      els.addToCartBtn.disabled = true;
      els.addToCartBtn.textContent = 'Wird hinzugefuegt...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Fehler beim Hinzufuegen zum Warenkorb.'); });
        return res.json();
      }).then(function () {
        els.addToCartBtn.textContent = 'Hinzugefuegt!';
        setTimeout(function () {
          els.addToCartBtn.textContent = 'In den Warenkorb';
          updateAddToCartState();
        }, 2000);
      }).catch(function (err) {
        console.error('CilsonKanalplaner: Add-to-Cart fehlgeschlagen.', err);
        window.alert('Fehler beim Hinzufuegen zum Warenkorb: ' + err.message);
        els.addToCartBtn.textContent = 'In den Warenkorb';
        updateAddToCartState();
      });
    }

    function resetAll() {
      state.segments = [];
      state.cuttingResult = null;
      recalculate();
    }

    els.productSelect.addEventListener('change', populateColorRow);
    els.addSegmentBtn.addEventListener('click', addSegment);
    els.resetBtn.addEventListener('click', resetAll);
    els.addToCartBtn.addEventListener('click', addToCart);
    window.addEventListener('resize', renderCanvas);

    populateProductSelect();
    populateColorRow();
    recalculate();
  }

  function csvEscape(value) {
      var str = String(value == null ? '' : value);
      if (/[",\n]/.test(str)) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    }

    function downloadTextFile(filename, mimeType, content) {
      var blob = new Blob([content], { type: mimeType });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    }

    function exportCuttingListCsv() {
      if (!state.cuttingResult) {
        window.alert('Es gibt noch keine berechnete Schneidliste. Bitte zuerst Segmente hinzufuegen.');
        return;
      }
      var rows = [['Stab', 'Position', 'Profil', 'Farbe', 'StartMm', 'EndMm', 'LaengeMm']];
      state.cuttingResult.rods.forEach(function (rod) {
        rod.pieces.forEach(function (piece) {
          rows.push([
            rod.rodNumber,
            piece.positionNumber,
            rod.productHandle,
            rod.colorCode,
            piece.startMm,
            piece.endMm,
            piece.endMm - piece.startMm
          ]);
        });
      });
      rows.push([]);
      rows.push(['Reststueck-ID', 'Stab', 'Profil', 'Farbe', 'LaengeMm', 'Entscheidung']);
      state.cuttingResult.leftovers.forEach(function (l) {
        rows.push([l.id, l.rodNumber, l.productHandle, l.colorCode, l.lengthMm, l.decision]);
      });
      var csv = rows.map(function (r) { return r.map(csvEscape).join(';'); }).join('\r\n');
      downloadTextFile('cilson-schneidliste.csv', 'text/csv;charset=utf-8', csv);
    }

    function exportProjectJson() {
      if (!state.cuttingResult) {
        window.alert('Es gibt noch keine berechnete Schneidliste. Bitte zuerst Segmente hinzufuegen.');
        return;
      }
      var payload = {
        exportedAt: new Date().toISOString(),
        stockLengthMm: stockLengthMm,
        product: state.selectedProduct,
        segments: state.segments,
        cuttingResult: state.cuttingResult
      };
      downloadTextFile('cilson-projekt.json', 'application/json;charset=utf-8', JSON.stringify(payload, null, 2));
    }

    var exportCsvBtnEl = document.getElementById('cilson-kp-export-csv-btn');
    var exportJsonBtnEl = document.getElementById('cilson-kp-export-json-btn');
    if (exportCsvBtnEl) exportCsvBtnEl.addEventListener('click', exportCuttingListCsv);
    if (exportJsonBtnEl) exportJsonBtnEl.addEventListener('click', exportProjectJson);

    ready(init);
})();
